import { stringifyFilter } from "./utils";

export function makeConversationQuery({
  startDate,
  endDate,
  offset,
  searchKey,
  orderBy,
  sortDesc,
  perPage,
  filter,
}) {
  return `{
    getConversations(
        start_date: "${startDate}", 
        end_date: "${endDate}", 
        offset: ${offset},
        limit: ${perPage},
        sort_by_field: "${orderBy}",
        sort_by_order: "${sortDesc === true ? "DESC" : "ASC"}",
        search_key: "${searchKey}",
        filters: ${filter.length > 0 ? stringifyFilter(filter) : "[]"}
    ) {
      total
      offset
      limit
      data {
        direction
        status
        created_at
        ended_at
        recipient_number
        recipient_name
        language
        agent_phone_number
        channel
        agent_name
        duration
        conversation_id
        language_code
      }
    }
    
}`;
}

export function makeAgentStatsQuery(startDate, endDate) {
  return `{
    getAgentStats(start_date: "${startDate}", end_date: "${endDate}") {
      averageDuration
      conversationCount
      conversationActivity {
        month
        inboundCount
        outboundCount
      }
      failedMessagesPercentage
      geolocationRequestCount {
        count
        graphData
      }
      messageCount {
        totalCount
        mmsCount
        smsCount
        othersCount
      }
      translationStats {
        language
        count
        language_code
      }
      videoSessions {
        count
        average
        graphData
      }
    }
  }`;
}

export function makeRecentActivitiesQuery({
  startDate,
  endDate,
  offset,
  searchKey,
  orderBy,
  sortDesc,
  perPage,
}) {
  return `{
    getActivities(
        start_date: "${startDate}", 
        end_date: "${endDate}", 
        offset: ${offset},
        limit: ${perPage},
        sort_by_field: "${orderBy}",
        sort_by_order: "${sortDesc === true ? "DESC" : "ASC"}",
        search_key: "${searchKey}"
    ) {
        total
        offset
        limit
        data {
            activity
            timestamp
            recipient_number
            agent_name
            conversation_id
            language
            language_code
        }
    }
}`;
}

export function makeRecentConversationQuery(startDate, endDate) {
  return `{
    getConversations(
      start_date: "${startDate}"
      end_date: "${endDate}"
      offset: 0
      limit: 30
    ) {
      total
      offset
      limit
      data {
        direction
        status
        created_at
        ended_at
        recipient_number
        recipient_name
        language
        agent_phone_number
        channel
        agent_name
        duration
        conversation_id
        language_code
      }
    }
  }
  `;
}

export function makeAdminStatsQuery(startDate, endDate) {
  return `{
    getAdminStats(start_date: "${startDate}", end_date: "${endDate}") {
      translationsCount
      geolocationRequestCount {
        count
        graphData
      }
      messageCount {
        totalCount
        mmsCount
        smsCount
        othersCount
      }
      videoSessions {
        count
        average
        graphData
      }
      invitations {
        pending
      }
      agencyUserStats {
        totalCount
        adminCount
        operatorCount
        otherCount
      }
      recentActivity {
        title
        timestamp
        recipient_number
      }
      conversationGraphStats {
        conversationCount
        averageDuration
        conversationActivity {
          month
          inboundCount
          outboundCount
        }
      }
      translationBreakdownStat {
        language
        count
        percentage
        language_code
      }
    }
  }`;
}

export function makeAdminGeoLocationStatsQuery(startDate, endDate) {
  return `{
    getAdminStats(start_date: "${startDate}", end_date: "${endDate}") {
      geolocationActivity {
        lng
        lat
        address
      }
    }
  }`;
}

export function makeAgentGeoLocationStatsQuery(startDate, endDate) {
  return `{
    getAgentStats(start_date: "${startDate}", end_date: "${endDate}") {
      geolocationActivity {
        lng
        lat
        address
      }
     
    }
  }`;
}

export function makeCampaignEventsQuery({
  offset,
  searchKey,
  campaignId,
  perPage,
  startDate,
  endDate,
  filter,
  orderBy,
  sortDesc,
}) {
  return `{
    getCampaignEvents(
      offset: ${offset}
      limit: ${perPage}
      campaign_id: "${campaignId}"
      start_date: "${startDate}"
      end_date: "${endDate}"
      search_key: "${searchKey}"
      sort_by_field: "${orderBy}",
      sort_by_order: "${sortDesc === true ? "DESC" : "ASC"}",
      filters: ${filter.length > 0 ? stringifyFilter(filter) : "[]"}
    ) {
      total
      limit
      offset
      data {
        event_id
        event_name
        total_subscribers
        created_at
        finished_at
        groups
        status
        duration
      }
    }
  }`;
}

export function makeCampaignEventSubscribersQuery({
  offset,
  searchKey,
  eventId,
  perPage,
}) {
  return `{
    getCampaignEventSubscribers(
      offset: ${offset}
      limit: ${perPage}
      event_id: "${eventId}"
      search_key: "${searchKey}"
    ) {
      subscriber_number
      status
      delivered_at
    }
  }`;
}

export function makeCampaignSubscribersQuery({
  offset,
  searchKey,
  campaignId,
  perPage,
  startDate,
  endDate,
  filter,
  orderBy,
  sortDesc
}) {
  return `{
    getCampaignSubscribers(
      offset: ${offset}
      limit: ${perPage}
      campaign_id: "${campaignId}"
      start_date: "${startDate}"
      end_date: "${endDate}"
      search_key: "${searchKey}"
      sort_by_field: "${orderBy}",
      sort_by_order: "${sortDesc === true ? "DESC" : "ASC"}",
      filters: ${filter.length > 0 ? stringifyFilter(filter) : "[]"}
    ) {
      total
      limit
      offset
      data {
        subscriber_id
        subscriber_number
        delivered_at
        status
        language
        verified_at
        created_at
        source
        attribution_source
        groups
      }
    }
  }`;
}

export function campaignStatsQuery(startDate, endDate) {
  return `{
    getCampaignStats(start_date: "${startDate}", end_date: "${endDate}") {
      totalCount
      totalMessagesCount
      undeliveredPercentage
      averageCampaignDuration
      messagesChartStats {
        totalCount
        statsData {
          x_axis
          count
        }
      }
      subscribersChartStats {
        x_axis
        optin
        optout
        total
      }
      subscriberEngagementStats {
        x_axis
        engagement
      }
      newSubscriberStats {
        totalCount
        statsData {
          x_axis
          count
        }
      }
      subscriberLanguageStats {
        language_code
        language
        count
        percentage
      }
    }
  }`;
}

export function conveyConnectStatsQuery(startDate, endDate) {
  return `{
    getConveyConnectStats(end_date: "${endDate}", start_date: "${startDate}") {
        stats {
            servicesChartData {
                name
                count
            }
            requesterRating
            callQualityRating
            interpreterRating
            interpreterRatingGraph
            requesterRatingGraph
            durationStats {
                totalDuration
                averageDuration
                averageQueueTime
            }
            callStatusChartData {
                label
                count
            }
            userAgents {
                os
                count
                browsers
            }
            accountCharges {
                total
                audio
                video
            }
            callsCount {
                total
                audio
                video
            }
        }
        callActivityGraphData {
            x_axis
            audio
            video
        }
      }
    }`;
}

export function recentCallsquery({
  startDate,
  endDate,
  offset,
  orderBy,
  sortDesc,
  perPage,
  searchKey,
  filter,
}) {
  return `{
      getConveyConnectCallHistory(
              end_date: "${endDate}", 
              start_date: "${startDate}", 
              offset: ${offset},
              limit: ${perPage},
              sort_by_field: "${orderBy}",
              sort_by_order: "${sortDesc}"
              search_key: "${searchKey}",
              filters: ${filter.length > 0 ? stringifyFilter(filter) : "[]"}
          ) {
          total
          offset
          limit
          data {
              id
              status
              createdTime
              interpreterName
              requestorName
              queueTimeSeconds
              invoiceAmount
              type
              duration
              interpreterNumber
              service
              rating
          }
      }
  }`;
}

export function makeGetCampaignStatsQuery(campaignEventId) {
  return `
    {
      getCampaign(event_id: "${campaignEventId}") {
        messagesStats {
          language
          message_count
        }
        messageSentStats {
          x_axis
          count
        }
        messsageDeliveryStats {
          status
          count
        }
      }
    }`;
}
